/**
 * WEB-3956 юнит 8 — раздел маршрутов «вход»: вход, регистрация, сброс пароля,
 * подтверждение почты. Собирает `router/index.tsx`.
 */
import { Navigate, type RouteObject } from 'react-router-dom';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { FirstSuspense } from '../suspense';

const LoginPage = lazyWithRetry(() => import('@/pages/Login'), 'page:Login');
const RegisterPage = lazyWithRetry(
  () => import('@/pages/Register'),
  'page:Register',
);
const ResetPasswordPage = lazyWithRetry(
  () => import('@/pages/ResetPassword'),
  'page:ResetPassword',
);
const VerifyEmailPage = lazyWithRetry(
  () => import('@/pages/VerifyEmail'),
  'page:VerifyEmail',
);

/** Маршруты входа; `isAdminHost` — поддомен админ-панели (`admin.<apex>`). */
export function authRoutes(isAdminHost: boolean): RouteObject[] {
  return [
    {
      path: '/login',
      element: <FirstSuspense><LoginPage /></FirstSuspense>,
    },
    {
      path: '/register',
      // WEB-471: no self-registration on the admin.<apex> subdomain — admins are
      // provisioned manually (DB). Direct /register there redirects to login.
      element: isAdminHost ? (
        <Navigate to="/login" replace />
      ) : (
        <FirstSuspense><RegisterPage /></FirstSuspense>
      ),
    },
    {
      path: '/reset-password',
      element: <FirstSuspense><ResetPasswordPage /></FirstSuspense>,
    },
    {
      path: '/verify-email',
      element: <FirstSuspense><VerifyEmailPage /></FirstSuspense>,
    },
  ];
}
